import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import Heading from "components/Heading/Heading";
import SectionHero from "components/SectionHero/SectionHero";

import SectionTextImage from "components/SectionTextImages/SectionTextImage";
import rightImg from "images/about-hero-right.png";
import featureRight from "images/finvue/availablemobile.png";
// images
import { ChartBarIcon, ClockIcon, CurrencyDollarIcon, UserGroupIcon } from "@heroicons/react/24/outline";
import BottomCTA from "components/CallToAction/BottomCTA";
import FaqSection from "components/FaqSections/FaqSection";
import FinVuePlans from "components/FinvueComponents/FinVuePlans/FinVuePlans";
import ExploreServicesSection from "components/services/ExploreServicesSection";
import KeyBenefitsSection, { BenefitCard } from "components/services/KeyBenefitsSection";
import invoiceSimplifiedImg from "images/finvue/services/invoice-simplified-bg.jpg";
import payrollSolutionsImg from "images/finvue/services/payment-management.jpg";
import schedulePaymentsImg from "images/finvue/services/schedule-payments-bg.jpg";
import staySecureOnlineImg from "images/finvue/services/stay-secure-online.jpg";
import streamlinedBatchImg from "images/finvue/services/streamlined-batch.jpg";
import foreignExchangeBlock1 from "images/new/foreign-exchange-block-1.png";
import foreignExchangeBlock2 from "images/new/foreign-exchange-block-2.png";
import servicesBg from "images/new/foreign-exchange-header-bg.png";
import arrow from "images/new/icons/arrow.svg";
import oneFeatureCenter from "images/one-section-cards-center.png";
import React from "react";
import SectionFounder from "./SectionFounder";
import SectionStatistic from "./SectionStatistic";
import StatCard from "./StatCard";

const statistics = [
  { value: "60", label: "Global Customers" },
  { value: "150", label: "Payment Locations" },
  { value: "3", label: "Offices" },
];

const forexBenefits: BenefitCard[] = [
  {
    id: 1,
    title: "Real-time FX transfers between accounts 24/7, 365 days a year.",
    icon: <ClockIcon className="w-8 h-8" />,
  },
  {
    id: 2,
    title: "Transparent FX rates displayed before transaction execution.",
    icon: <ChartBarIcon className="w-8 h-8" />,
  },
  {
    id: 3,
    title: "Competitive FX rates for international payments.",
    icon: <CurrencyDollarIcon className="w-8 h-8" />,
  },
  {
    id: 4,
    title: "Expert treasury team support for complex transactions.",
    icon: <UserGroupIcon className="w-8 h-8" />,
  },
];

const ForeignExchangePage = () => {
  return (
    <div className={`nc-PageAbout relative`}>
      {/* ======== BG GLASS ======== */}

      <div className="rounded-b-2xl">
        <SectionHero
          centerImg={servicesBg}
          centerImgClasses="rounded-b-2xl"
          className="rounded-b-2xl"
          topHeading={<span className="text-white text-xs">Foreign Exchange</span>}
          heading={
            <span className="text-2xl px-4 md:px-0 font-black lg:text-5xl text-slate-50">
              Currency Exchange
              <br />
              You Can Trust
            </span>
          }
          btnTextPrimary="Get started"
          btnPrimaryUrl="/sign-up"
          btnTextSecondary="Contact Sales"
          btnSecondaryUrl="/contact"
          subHeading="Make your money work worldwide, for less. Send, spend and get paid. 21 currencies. All at your fingertips."
          subHeadingColor="text-slate-200 px-4"
        />
      </div>
      <section className="relative py-6 md:py-16">
        <ExploreServicesSection />
      </section>

      <section className="relative py-6 md:py-16">
        <KeyBenefitsSection benefits={forexBenefits} />
      </section>

      <section className="relative py-6 md:py-16">
        <div className="container">
          {/* <BackgroundSection /> */}
          <SectionTextImage
            rightImg={foreignExchangeBlock1}
            imageClasses=""
            beforeTitle="Plan smarter"
            title={<h3 className="text-2xl md:text-4xl font-normal">Transfer funds between your accounts instantly, 24/7, 365 days a year.</h3>}
            afterTitle=""
          />
        </div>
      </section>
      <section className="relative py-16">
        <div className="container">
          {/* <BackgroundSection /> */}
          <SectionTextImage
            leftImg={foreignExchangeBlock2}
            imageClasses=""
            beforeTitle="Plan smarter"
            title={<h3 className="text-normal md:text-xl font-bold">See the FX rate before you execute so you're always in control.</h3>}
            afterTitle="Plus, our Treasury Team is on hand to offer competitive rates for your international payments. It's not just exchanging currencies – it's exchanging limitations for opportunities."
            buttonText="Contact us to find out more"
            buttonLink="/contact"
          />
        </div>
      </section>

      <section className="relative">
        <BottomCTA />
      </section>

      {/* <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
        <section className="rounded-[30px]">
          <div className="flex gap-5 max-md:flex-col">
            {statistics.map((stat, index) => (
              <div key={index} className="flex flex-col w-[33%] max-md:ml-0 max-md:w-full">
                <StatCard value={stat.value} label={stat.label} />
              </div>
            ))}
          </div>
        </section>
      </div> */}
      <section>
        <FinVuePlans />
      </section>
    </div>
  );
};

export default ForeignExchangePage;
